import React from 'react';
import { useFocused, useReadOnly } from 'slate-react';

import { isPopulated } from '../../utils/doc-editor';

import DocNodeWithChooser from '../doc-node-with-chooser';
import FileContainer from '../../containers/file-container';
import EmbedPane from 'components/EmbedPane';

const DocImage = ({ attributes, children, element, fileId, fileUrl, useUrl, isPublic, menuItems, onRemove, onNodeChange }) => {
    const readOnly = useReadOnly();

    const handleMenuAction = type => {
        onNodeChange && onNodeChange(element, type);
    }

    const handleClick = () => {
        // this.props.editor.moveToRangeOfNode(this.props.node);
    }

    const handleRemoveClick = () => {
        onRemove(element);
    }

    const hasCaption = isPopulated(element);
    const isFocused = useFocused();

    return (
        <DocNodeWithChooser current={element.type} element={attributes.ref.current} items={menuItems} depth={1} onAction={handleMenuAction}>
            <div className={'doc-node doc-media' + (isFocused ? ' focused' : '')} {...attributes}>
                <div className="doc-media-main">
                    <div className="doc-media-preview" contentEditable={false} onClick={handleClick}>
                        {
                            fileId && !useUrl ? (
                                <FileContainer id={fileId}>
                                    <EmbedPane isImage={true} expandDisabled={isPublic} onRemove={!readOnly && handleRemoveClick} />
                                </FileContainer>
                            ) : <EmbedPane url={fileUrl} isImage={true} expandDisabled={isPublic} onRemove={!readOnly && handleRemoveClick} />
                        }
                    </div>

                    <div className={'doc-media-caption' + (!hasCaption ? ' empty' : '')}>{children}</div>
                </div>
            </div>
        </DocNodeWithChooser>
    )
}

export default DocImage;
